import { createSelector } from 'reselect'

import { LandingOffering } from 'partner360/models/landing/LandingOffering'

import { selectLandingState } from './selectLandingState'

export const selectLandingPartnersIds = createSelector(
  [selectLandingState],
  ({
    processedPlannings,
    selectedPlanning,
    selectedOffering,
    selectedCategory,
    selectedStatus,
  }) => {
    if (selectedOffering === LandingOffering.Total) {
      return Array.from(
        new Set(
          processedPlannings
            .filter(
              (el) =>
                el.planningId === selectedPlanning.PlanningId &&
                el.category === selectedCategory &&
                el.status === selectedStatus
            )
            .map((el) => el.partnerId)
        )
      )
    }

    return Array.from(
      new Set(
        processedPlannings
          .filter(
            (el) =>
              el.planningId === selectedPlanning.PlanningId &&
              el.offering === selectedOffering &&
              el.category === selectedCategory &&
              el.status === selectedStatus
          )
          .map((el) => el.partnerId)
      )
    )
  }
)
